import React from 'react';
import { TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';
import { TableHeader } from '../../../Common/CommonModel';
import { AzureSearchService } from '../Model/AzureSearchServiceModel';
import { EnhancedTableProps } from '../Model/AzureSearchServiceProps';

const headCells: TableHeader<AzureSearchService>[] = [
  {
    id: 'Name',
    numeric: false,
    disablePadding: false,
    label: 'Name',
    enableSorting: true,
  },
  {
    id: 'ResourceGroup',
    numeric: false,
    disablePadding: false,
    label: 'Resource Group',
    enableSorting: true,
  },
  {
    id: 'Subscription',
    numeric: false,
    disablePadding: false,
    label: 'Subscription',
    enableSorting: true,
  },
  {
    id: 'ProductID',
    numeric: false,
    disablePadding: false,
    label: 'Product ID',
    enableSorting: true,
  },
  {
    id: 'AzureRegion',
    numeric: false,
    disablePadding: false,
    label: 'Azure Region',
    enableSorting: true,
  },
];

const AzureSearchServicesTableHead: React.FC<EnhancedTableProps> = ({
  order,
  orderBy,
  onRequestSort,
}) => {
  const createSortHandler =
    (property: keyof AzureSearchService) => (event: React.MouseEvent) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.enableSorting ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(
                  headCell.id as keyof AzureSearchService,
                )}
              >
                {headCell.label}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default AzureSearchServicesTableHead;
